import React from 'react';
import { Popup } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import { ValuesCache } from '@leverege/value-cache';
import { GroupDelegate } from '@leverege/molten-core';
import { FilterSourcesModel, FilterSourceModel } from "../index.js";
import SortModelInitializer from "./SortModelInitializer.js";
import FilterSortMetadataModel from "../filter/FilterSortMetadataModel.js";
import { EMPTY_FILTER_SOURCE } from "../../dataViewers/Util.js";
import AttributeSortFieldModel from "./AttributeSortFieldModel.js";
import AttributeSortModel from "./AttributeSortModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tIcon,
  t
} = I18N.ns('molten.sort.SortActionRenderer');
export default class SortActionRenderer extends React.Component {
  static getDerivedStateFromProps(props, state) {
    const {
      context: {
        objectType,
        filters,
        filterName = 'filterBar',
        clientProps
      }
    } = props;
    const {
      delegate
    } = clientProps;
    const pSort = FilterSourcesModel.getSource(filters, filterName)?.metadata?.sort;
    const sSort = state.value;
    if (pSort !== sSort) {
      return {
        value: pSort || SortModelInitializer.create(delegate.type, objectType)
      };
    }
    return null;
  }
  constructor(props) {
    super(props);
    this.cache = new ValuesCache();
    this.state = {
      opened: false,
      value: null
    };
  }
  componentDidMount() {
    const {
      context: {
        objectType
      }
    } = this.props;
    window.addEventListener(`molten.sortAsc.${objectType}.open`, this.onOpenSort);
    window.addEventListener(`molten.sortDesc.${objectType}.open`, this.onOpenSort);
  }
  componentWillUnmount() {
    const {
      context: {
        objectType
      }
    } = this.props;
    window.removeEventListener(`molten.sortAsc.${objectType}.open`, this.onOpenSort);
    window.removeEventListener(`molten.sortDesc.${objectType}.open`, this.onOpenSort);
  }
  onOpenSort = evt => {
    const {
      value
    } = this.state;
    const {
      detail,
      type
    } = evt;
    const order = type.includes('.sortAsc') ? 'asc' : 'desc';
    const missing = order === 'asc' ? '_first' : '_last';
    const attrName = detail?.attrName;
    if (attrName) {
      const sort = AttributeSortFieldModel.create({
        order,
        missing,
        attrName
      });
      let nSortModel;
      if (value?.fields?.length === 1 && value.fields[0].attrName == null) {
        nSortModel = AttributeSortModel.setField(value, 0, sort);
      } else {
        nSortModel = AttributeSortModel.addField(value, sort);
      }
      this.setState({
        value: nSortModel,
        opened: true
      });
      this.onChange({
        value: nSortModel
      });
    } else {
      this.setState({
        opened: true
      });
    }
  };
  onPopupChange = ({
    isOpened
  }) => {
    const {
      context
    } = this.props;
    const {
      filters,
      filterName = 'filterBar',
      clientProps
    } = context;
    const {
      delegate
    } = clientProps;
    this.setState({
      opened: isOpened
    });
    const filter = FilterSourcesModel.getSource(filters, filterName) || EMPTY_FILTER_SOURCE;
    this.setState({
      value: filter?.metadata?.sort || SortModelInitializer.create(delegate.type, context.objectType),
      opened: isOpened
    });
  };
  onChange = ({
    value
  }) => {
    const {
      context
    } = this.props;
    const {
      filters,
      filterName = 'filterBar',
      onFilterChange,
      clientProps
    } = context;
    const {
      delegate
    } = clientProps;
    const filter = FilterSourcesModel.getSource(filters, filterName) || EMPTY_FILTER_SOURCE;
    const sort = delegate?.convertToSort?.(value, context);
    const metadata = FilterSortMetadataModel.setSort(filter.metadata || {}, value);
    let filterModel = FilterSourceModel.setMetadata(filter, metadata);
    filterModel = FilterSourceModel.setSort(filterModel, sort);
    onFilterChange({
      value: filterModel,
      data: filterName
    });
    this.setState({
      value
    });
  };
  getSortCount(value) {
    const {
      context
    } = this.props;
    const {
      clientProps
    } = context;
    const {
      delegate
    } = clientProps;
    return this.cache.calc('sortCount', () => {
      if (delegate.type === GroupDelegate.TYPE) {
        const sorts = delegate.convertToSort(value, context);
        return sorts?.length || 0;
      }
      return 0;
    }, value);
  }
  render() {
    const {
      context
    } = this.props;
    const {
      clientProps,
      mobile,
      relationship
    } = context;
    const {
      delegate
    } = clientProps;
    const {
      opened,
      value
    } = this.state;
    const editor = ModelEditorFactory.create(value, {
      context,
      delegate,
      relationship,
      onChange: this.onChange
    });
    const sortCount = this.getSortCount(value);
    return /*#__PURE__*/_jsx(Popup, {
      variant: "sort",
      opened: opened,
      onChange: this.onPopupChange,
      style: {
        color: sortCount > 0 ? 'var(--color-sortApplied, #0C8599)' : undefined
      },
      toggleVariant: mobile ? 'mobileSort|mobileActionBar' : 'sort|sortFilterBar|actionBar',
      icon: tIcon('sortIcon'),
      title: t('nameWithCount', {
        count: sortCount
      }),
      children: editor
    });
  }
}